import React from "react";
import PropTypes from "prop-types";
import Col from "core/Col";
import { BUNNY_VIDEO_IFRAME_ID } from "core/video/BunnyStreamPlayer";

const EMPTY_VIDEO_DOCUMENT = `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
        html,
        body {
          background: #000;
          margin: 0;
          overflow: hidden;
        }
      </style>
    </head>
    <body></body>
  </html>
`;

function BunnyVideoEmbed({ id, videoUrl }) {
  return (
    <Col width="100%" position="relative" paddingTop="56.25%" backgroundColor="#000" overflow="hidden">
      <iframe
        id={id}
        title="Video"
        src="about:blank"
        srcDoc={EMPTY_VIDEO_DOCUMENT}
        data-video-url={videoUrl}
        loading="lazy"
        tabIndex={-1}
        style={{
          border: "0",
          pointerEvents: "none",
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media;"
        allowFullScreen={false}
      />
    </Col>
  );
}

BunnyVideoEmbed.defaultProps = {
  id: BUNNY_VIDEO_IFRAME_ID,
  videoUrl: "",
};

BunnyVideoEmbed.propTypes = {
  id: PropTypes.string,
  videoUrl: PropTypes.string,
};

export default BunnyVideoEmbed;
